import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgFilm = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm0 2a9 9 0 1 1 0 18 9 9 0 0 1 0-18Z" />
      <path d="M12 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM12 14a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM7.5 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM16.5 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM22 21a1 1 0 0 1 .117 1.993L22 23H12a1 1 0 0 1-.117-1.993L12 21h10Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgFilm)
const Memo = memo(ForwardRef)
export default Memo
